import { environment } from "@/environment/environment";
import axios from "axios";
import { ResponseDeleteUserDevEnv, User, ZimperiumGroup } from "./types";
const { apiUrl: baseUrl } = environment
import { ContentMobile, Device, Mobile } from "@/interfaces/types";
import { laptopSentiRequest } from "@/requests/laptopSentiRequest";


export function adminRequests(){

    const getAllUsersAdmin = async (): Promise<User[]|null> => {
        try {
            const response = await axios.get(`${baseUrl}/user/getAllUsersAdmin`);
            return response.data
        } catch (errors) {
            console.log("🚀 ~ getAllUsersAdmin ~ errors:", errors)
            return null
        }
    }

    const blockAccount = async (id: string, email: string): Promise<boolean> => {
        try {
            const response = await axios.post(`${baseUrl}/user/blockAccount`, {
                    email: email,
                    id: id,
                    value: true
            })
            return response.data
        } catch (error) {
            console.log(error)
            return false
        }
    }

    const unlockAccount = async (id: string, email: string): Promise<boolean> => {
        try {
            const response = await axios.post(`${baseUrl}/user/blockAccount`, {
                    email: email,
                    id: id,
                    value: false
            })
            return response.data
        } catch (error) {
            console.log(error)
            return false
        }
    }

    const getMobilesForUserId = async(userId: number): Promise<ContentMobile[]|null> => {
        try {
            const response = await axios.get(`${baseUrl}/mobile/getZimperiumDevices`, {
                params: {
                    userId: userId,
                }
            })
            return response.data as ContentMobile[]
        } catch (error) {
            console.log("🚀 ~ getMobilesForUserId ~ errors:", error)
            return null
        }
    }

    const getZimperiumGroupIds = async(): Promise<ZimperiumGroup[]|null> => {
        try {
            const response = await axios.get(`${baseUrl}/user/getZimperiumGroupIds`)
            return response.data as ZimperiumGroup[]
        } catch (error) {
            console.log("🚀 ~ getZimperiumGroupIds ~ errors:", error)
            return null
        }
    }

    const getDatabaseMobiles = async(ids: string[]): Promise<Mobile[]|null> => {
        try {
            const response = await axios.get(`${baseUrl}/mobile/getDatabaseMobile`, {
                params: {ids: ids}
            })
            return response.data
        } catch (error) {
            console.log("🚀 ~ getDatabaseMobiles ~ errors:", error)
            return null
        }
    }

    const deleteMobileDatabase = async(zimperiumId: string, activationEmail: string, userEmail: string): Promise<boolean> => {
        try {
            const response = await axios.get(`${baseUrl}/mobile/deleteMobileDatabase`, {
                params: {
                    zimperiumId: zimperiumId,
                    activationEmail: activationEmail,
                    userEmail: userEmail
                }
            })
            return response.data
        } catch (error) {
            console.log("🚀 ~ deleteMobileDatabase ~ errors:", error)
            return false
        }
    }

    const getActiveLicenseAdmin = async(userId: number): Promise<number|null> => {
        try {
            const response = await axios.get(`${baseUrl}/user/getActiveLicenseAdmin`, {
                params: {userId: userId}
            });
            return response.data
        } catch (error) {
            console.log("🚀 ~ getActiveLicenseAdmin ~ error:", error)
            return null
        }
    }

    const getUsedLicenseAdmin = async(groupId: string, userId: number): Promise<{laptopCount: number, mobileCount: number}|null> => {
        try {
            const response = await axios.get(`${baseUrl}/user/getUsedLicenseAdmin`, {
                params: {groupId: groupId, userId: userId}
            });
            return response.data
        } catch (error) {
            console.log("🚀 ~ getUsedLicenseAdmin ~ error:", error)
            return null
        }
    }

    const getLaptopDataForGroupIdUser = async (groupId: string): Promise<Device[]> => {
        const { adjustDateToTimeZoneUser } = laptopSentiRequest()

        try {
            const response = await axios.get(`${baseUrl}/getDevicesData`, {
                params: {
                    groupId: groupId
                }
            });
            const responseDevices = response.data as Device[]
            const adjustData = await adjustDateToTimeZoneUser(responseDevices)
            
            return adjustData
        } catch (errors) {
            console.log("🚀 ~ getLaptopDataForGroupIdUser ~ errors", errors)
            return []
        }
    };

    const reachServices = async (): Promise<{
        zimperium: boolean,
        sentinelOne: boolean,
        wordPress: boolean,
        backend: boolean,
        database: boolean
    }|null> => {
        try {
            const response = await axios.get(`${baseUrl}/user/reachServices`);
            return response.data
        } catch (error) {
            console.log("🚀 ~ reachServices ~ errors", error)
            return null
        }
    }


    const deleteUserDevEnv = async(email: string): Promise<ResponseDeleteUserDevEnv|null> => {
        try {
            const response = await axios.post(`${baseUrl}/user/deleteUserDevEnv`, {
                email: email
            })
            return response.data
        } catch (error) {
            console.log("🚀 ~ deleteUserDevEnv ~ error:", error)
            return null
        }
    }



    return {
        getAllUsersAdmin,
        blockAccount,
        unlockAccount,
        getMobilesForUserId,
        getZimperiumGroupIds,
        getDatabaseMobiles,
        deleteMobileDatabase,
        getUsedLicenseAdmin,
        getActiveLicenseAdmin,
        getLaptopDataForGroupIdUser,
        reachServices,
        deleteUserDevEnv
    }
}
